import { SimpleTable } from '../../SimpleTable';
import {
  durationInHours,
  shiftDateTimeFormat,
} from '../../../lib/utils/date-time';
import { format } from 'date-fns';
import ShiftDisplayHeading from './ShiftDisplayHeading';
import {
  formatRecurrenceDate,
  formatRecurrencePattern,
} from '../lib/changeLog';

/**
 * Renders details of a shift.
 * This component is readonly.
 */
const ShiftDetails: React.FC<{
  readonly employee: string | undefined;
  readonly times: Interval;
  readonly status: string;
  readonly titleWidth: string;
  readonly role: string;
  readonly recurrence: { readonly pattern?: string; readonly endDate?: string };
}> = ({ status, titleWidth, role, times, employee, recurrence }) => {
  const isVacantShift = employee === undefined || employee === '';
  return (
    <div>
      <ShiftDisplayHeading
        role={role}
        employee={employee}
        startTime={format(times.start, 'PPP')}
        isVacant={isVacantShift}
      />

      <SimpleTable
        firstColumnWidth={titleWidth}
        rows={[
          {
            title: 'Start Time:',
            content: format(times.start, shiftDateTimeFormat),
          },
          {
            title: 'Duration:',
            content: `${durationInHours(times.start, times.end)}h`,
          },
          {
            title: 'End Time:',
            content: format(times.end, shiftDateTimeFormat),
          },
          { title: 'Status:', content: status },
          ...(recurrence.pattern === undefined || recurrence.pattern === ''
            ? []
            : [
                {
                  title: 'Recurrence:',
                  content: formatRecurrencePattern(recurrence.pattern),
                },
                {
                  title: 'Recurrence End Date:',
                  content: formatRecurrenceDate(recurrence.endDate, 'N/A'),
                },
              ]),
        ]}
      />
    </div>
  );
};

export default ShiftDetails;
